import React, { useState } from "react";
import { Button, TextField, Typography, Container } from "@mui/material";
import { useParams, useNavigate } from "react-router-dom";
import { ResetPassword } from "../utils/usersAPI";

const ResetPasswordPage = () => {
  const { token } = useParams();
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const handleReset = async () => {
    setError("");
    setMessage("");

    if (!newPassword || !confirmPassword) {
      setError("חובה למלא את כל השדות");
      return;
    }

    if (newPassword.length < 6) {
      setError("הסיסמה חייבת להכיל לפחות 6 תווים");
      return;
    }

    if (newPassword !== confirmPassword) {
      setError("הסיסמאות אינן תואמות");
      return;
    }

    try {
      const res = await ResetPassword(token, newPassword);
      setMessage(res.data);

      setTimeout(() => {
        navigate("/signIn");
      }, 1500);
    } catch (err) {
      setError(err.response?.data || "אירעה שגיאה באיפוס הסיסמה");
    }
  };

  return (
    <Container maxWidth="xs" style={{ marginTop: "140px" }}>
      <Typography variant="h4" align="center" gutterBottom>
        איפוס סיסמה
      </Typography>

      <TextField
        label="סיסמה חדשה"
        type="password"
        fullWidth
        value={newPassword}
        onChange={(e) => setNewPassword(e.target.value)}
      />

      <br /><br />

      <TextField
        label="אימות סיסמה"
        type="password"
        fullWidth
        value={confirmPassword}
        onChange={(e) => setConfirmPassword(e.target.value)}
      />

      <br /><br />

      <Button variant="contained" fullWidth onClick={handleReset}>
        עדכון סיסמה
      </Button>

      {message && <Typography color="green">{message}</Typography>}
      {error && <Typography color="error">{error}</Typography>}
    </Container>
  );
};

export default ResetPasswordPage;